// eslint-disable-next-line no-shadow
enum EventStatus {
  DRAFT,
  PENDING,
  ACTIVE,
  REFUSED,
  BLOCKED,
  FINISHED,
  INACTIVE,
  COMPLETED,
}
export default EventStatus;
